export const LOCATOR_DATA = [
    {
        hostName: 'Skyline Ventures',
        territoryName: 'Metro North District',
        longitude: [-74.006, -73.9857, -73.9442],
        totalArea: 12500.75,
        latitude: [40.7128, 40.758, 40.6892],
        assignedDealer: 'DLR-00492',
        createdDate: '2024-03-15T08:42:00Z',
        host: [
            {
                hostName: 'Skyline Ventures',
                address: '142 Orchard Blvd, Suite 300, New York, NY 10001',
                latitude: 40.7128,
                longitude: -74.006,
                licenses: ['LIC-NY-2024-001', 'LIC-NY-2024-089', 'LIC-FED-2023-774'],
                operationHours: {
                    monday: { open: '10:00 AM', close: '08:00 PM' },
                    tuesday: { open: '10:00 AM', close: '08:00 PM' },
                    wednesday: { open: '10:00 AM', close: '08:00 PM' },
                    thursday: { open: '10:00 AM', close: '08:00 PM' },
                    friday: { open: '10:00 AM', close: '08:00 PM' },
                    saturday: { open: '09:00 AM', close: '08:00 PM' },
                    sunday: { open: '10:00 AM', close: '06:00 PM' },
                },
            },
            {
                hostName: 'Pinnacle Holdings LLC',
                address: '78 Commerce Drive, Albany, NY 12203',
                latitude: 42.6526,
                longitude: -73.7562,
                licenses: ['LIC-NY-2023-412', 'LIC-STT-2024-056'],
                operationHours: {
                    monday: { open: '10:00 AM', close: '08:00 PM' },
                    tuesday: { open: '10:00 AM', close: '08:00 PM' },
                    wednesday: { open: '10:00 AM', close: '08:00 PM' },
                    thursday: { open: '10:00 AM', close: '08:00 PM' },
                    friday: { open: '10:00 AM', close: '08:00 PM' },
                    saturday: { open: '09:00 AM', close: '08:00 PM' },
                    sunday: { open: '10:00 AM', close: '06:00 PM' },
                },
            },
            {
                hostName: 'Eastridge Properties',
                address: '901 Industrial Park Rd, Buffalo, NY 14201',
                latitude: 42.8864,
                longitude: -78.8784,
                licenses: ['LIC-NY-2022-998', 'LIC-FED-2024-130'],
                operationHours: {
                    monday: { open: '10:00 AM', close: '08:00 PM' },
                    tuesday: { open: '10:00 AM', close: '08:00 PM' },
                    wednesday: { open: '10:00 AM', close: '08:00 PM' },
                    thursday: { open: '10:00 AM', close: '08:00 PM' },
                    friday: { open: '10:00 AM', close: '08:00 PM' },
                    saturday: { open: '09:00 AM', close: '08:00 PM' },
                    sunday: { open: '10:00 AM', close: '06:00 PM' },
                },
            },
        ],
        state: 'New York',
        dealers: [
            { dealerName: 'Reynolds Auto & Distribution', dealerId: 'DLR-00492' },
            { dealerName: 'Empire State Dealers', dealerId: 'DLR-00503' },
        ],
        category: 'Commercial',
        status: 'Active',
    },
    {
        hostName: 'Coastal Edge Group',
        territoryName: 'Southern Bay Zone',
        longitude: [-80.1918, -81.3792, -82.4572],
        totalArea: 8340.5,
        latitude: [25.7617, 28.5383, 27.9506],
        assignedDealer: 'DLR-00817',
        createdDate: '2023-11-02T14:20:00Z',
        host: [
            {
                hostName: 'Coastal Edge Group',
                address: '55 Bayview Ave, Miami, FL 33101',
                latitude: 25.7617,
                longitude: -80.1918,
                licenses: ['LIC-FL-2023-301', 'LIC-FED-2023-512'],
                operationHours: {
                    monday: { open: '10:00 AM', close: '08:00 PM' },
                    tuesday: { open: '10:00 AM', close: '08:00 PM' },
                    wednesday: { open: '10:00 AM', close: '08:00 PM' },
                    thursday: { open: '10:00 AM', close: '08:00 PM' },
                    friday: { open: '10:00 AM', close: '08:00 PM' },
                    saturday: { open: '09:00 AM', close: '08:00 PM' },
                    sunday: { open: '10:00 AM', close: '06:00 PM' },
                },
            },
            {
                hostName: 'Sunbelt Realty Partners',
                address: '220 Palm Street, Orlando, FL 32801',
                latitude: 28.5383,
                longitude: -81.3792,
                licenses: ['LIC-FL-2022-874', 'LIC-STT-2023-190', 'LIC-FED-2022-667'],
                operationHours: {
                    monday: { open: '10:00 AM', close: '08:00 PM' },
                    tuesday: { open: '10:00 AM', close: '08:00 PM' },
                    wednesday: { open: '10:00 AM', close: '08:00 PM' },
                    thursday: { open: '10:00 AM', close: '08:00 PM' },
                    friday: { open: '10:00 AM', close: '08:00 PM' },
                    saturday: { open: '09:00 AM', close: '08:00 PM' },
                    sunday: { open: '10:00 AM', close: '06:00 PM' },
                },
            },
        ],
        state: 'Florida',
        dealers: [
            { dealerName: 'Harborview Logistics Inc.', dealerId: 'DLR-00817' },
            { dealerName: 'Sunshine State Motors', dealerId: 'DLR-00829' },
            { dealerName: 'Gulf Coast Auto Group', dealerId: 'DLR-00845' },
        ],
        category: 'Residential',
        status: 'Active',
    },
    {
        hostName: 'Iron Peak Industries',
        territoryName: 'Central Plains Corridor',
        longitude: [-94.5786, -90.1994, -93.2923],
        totalArea: 31200.0,
        latitude: [39.0997, 38.627, 37.2153],
        assignedDealer: 'DLR-00231',
        createdDate: '2022-07-19T09:05:00Z',
        host: [
            {
                hostName: 'Iron Peak Industries',
                address: '4400 Industrial Loop, Kansas City, MO 64101',
                latitude: 39.0997,
                longitude: -94.5786,
                licenses: ['LIC-MO-2022-045', 'LIC-FED-2021-889'],
                operationHours: {
                    monday: { open: '10:00 AM', close: '08:00 PM' },
                    tuesday: { open: '10:00 AM', close: '08:00 PM' },
                    wednesday: { open: '10:00 AM', close: '08:00 PM' },
                    thursday: { open: '10:00 AM', close: '08:00 PM' },
                    friday: { open: '10:00 AM', close: '08:00 PM' },
                    saturday: { open: '09:00 AM', close: '08:00 PM' },
                    sunday: { open: '10:00 AM', close: '06:00 PM' },
                },
            },
            {
                hostName: 'Midlands Supply Co.',
                address: '1880 Commerce Blvd, St. Louis, MO 63101',
                latitude: 38.627,
                longitude: -90.1994,
                licenses: ['LIC-MO-2023-310'],
                operationHours: {
                    monday: { open: '10:00 AM', close: '08:00 PM' },
                    tuesday: { open: '10:00 AM', close: '08:00 PM' },
                    wednesday: { open: '10:00 AM', close: '08:00 PM' },
                    thursday: { open: '10:00 AM', close: '08:00 PM' },
                    friday: { open: '10:00 AM', close: '08:00 PM' },
                    saturday: { open: '09:00 AM', close: '08:00 PM' },
                    sunday: { open: '10:00 AM', close: '06:00 PM' },
                },
            },
            {
                hostName: 'Heartland Distributors',
                address: '700 Grain Exchange Rd, Springfield, MO 65801',
                latitude: 37.2153,
                longitude: -93.2923,
                licenses: ['LIC-MO-2021-567', 'LIC-STT-2022-443', 'LIC-FED-2023-221'],
                operationHours: {
                    monday: { open: '10:00 AM', close: '08:00 PM' },
                    tuesday: { open: '10:00 AM', close: '08:00 PM' },
                    wednesday: { open: '10:00 AM', close: '08:00 PM' },
                    thursday: { open: '10:00 AM', close: '08:00 PM' },
                    friday: { open: '10:00 AM', close: '08:00 PM' },
                    saturday: { open: '09:00 AM', close: '08:00 PM' },
                    sunday: { open: '10:00 AM', close: '06:00 PM' },
                },
            },
        ],
        state: 'Missouri',
        dealers: [
            { dealerName: 'Prairie Star Dealers', dealerId: 'DLR-00231' },
            { dealerName: 'Midwest Auto Partners', dealerId: 'DLR-00244' },
        ],
        category: 'Industrial',
        status: 'Inactive',
    },
    {
        hostName: 'Pacific Rim Enterprises',
        territoryName: 'West Coast Hub',
        longitude: [-118.2437, -122.4194, -121.8863],
        totalArea: 19875.25,
        latitude: [34.0522, 37.7749, 37.3382],
        assignedDealer: 'DLR-01105',
        createdDate: '2024-01-08T11:30:00Z',
        host: [
            {
                hostName: 'Pacific Rim Enterprises',
                address: '1200 Harbor Way, Los Angeles, CA 90001',
                latitude: 34.0522,
                longitude: -118.2437,
                licenses: ['LIC-CA-2024-102', 'LIC-FED-2024-305'],
                operationHours: {
                    monday: { open: '10:00 AM', close: '08:00 PM' },
                    tuesday: { open: '10:00 AM', close: '08:00 PM' },
                    wednesday: { open: '10:00 AM', close: '08:00 PM' },
                    thursday: { open: '10:00 AM', close: '08:00 PM' },
                    friday: { open: '10:00 AM', close: '08:00 PM' },
                    saturday: { open: '09:00 AM', close: '08:00 PM' },
                    sunday: { open: '10:00 AM', close: '06:00 PM' },
                },
            },
            {
                hostName: 'GoldenGate Assets LLC',
                address: '340 Market Street, San Francisco, CA 94101',
                latitude: 37.7749,
                longitude: -122.4194,
                licenses: ['LIC-CA-2023-789', 'LIC-STT-2023-654'],
                operationHours: {
                    monday: { open: '10:00 AM', close: '08:00 PM' },
                    tuesday: { open: '10:00 AM', close: '08:00 PM' },
                    wednesday: { open: '10:00 AM', close: '08:00 PM' },
                    thursday: { open: '10:00 AM', close: '08:00 PM' },
                    friday: { open: '10:00 AM', close: '08:00 PM' },
                    saturday: { open: '09:00 AM', close: '08:00 PM' },
                    sunday: { open: '10:00 AM', close: '06:00 PM' },
                },
            },
        ],
        state: 'California',
        dealers: [
            { dealerName: 'Westside Premier Motors', dealerId: 'DLR-01105' },
            { dealerName: 'Pacific Coast Auto', dealerId: 'DLR-01118' },
            { dealerName: 'Bay Area Dealers LLC', dealerId: 'DLR-01127' },
        ],
        category: 'Commercial',
        status: 'Pending',
    },
    {
        hostName: 'BlueStar Management',
        territoryName: 'Great Lakes Region',
        longitude: [-87.6298, -83.0458, -87.9065],
        totalArea: 24650.8,
        latitude: [41.8781, 42.3314, 43.0389],
        assignedDealer: 'DLR-00673',
        createdDate: '2023-05-27T16:55:00Z',
        host: [
            {
                hostName: 'BlueStar Management',
                address: '890 Lakefront Dr, Chicago, IL 60601',
                latitude: 41.8781,
                longitude: -87.6298,
                licenses: ['LIC-IL-2023-211', 'LIC-FED-2022-934'],
                operationHours: {
                    monday: { open: '10:00 AM', close: '08:00 PM' },
                    tuesday: { open: '10:00 AM', close: '08:00 PM' },
                    wednesday: { open: '10:00 AM', close: '08:00 PM' },
                    thursday: { open: '10:00 AM', close: '08:00 PM' },
                    friday: { open: '10:00 AM', close: '08:00 PM' },
                    saturday: { open: '09:00 AM', close: '08:00 PM' },
                    sunday: { open: '10:00 AM', close: '06:00 PM' },
                },
            },
            {
                hostName: 'Lakeview Capital Group',
                address: '310 Michigan Ave, Detroit, MI 48201',
                latitude: 42.3314,
                longitude: -83.0458,
                licenses: ['LIC-MI-2023-504', 'LIC-STT-2023-877'],
                operationHours: {
                    monday: { open: '10:00 AM', close: '08:00 PM' },
                    tuesday: { open: '10:00 AM', close: '08:00 PM' },
                    wednesday: { open: '10:00 AM', close: '08:00 PM' },
                    thursday: { open: '10:00 AM', close: '08:00 PM' },
                    friday: { open: '10:00 AM', close: '08:00 PM' },
                    saturday: { open: '09:00 AM', close: '08:00 PM' },
                    sunday: { open: '10:00 AM', close: '06:00 PM' },
                },
            },
            {
                hostName: 'Northshore Trading Co.',
                address: '515 Brewery Lane, Milwaukee, WI 53201',
                latitude: 43.0389,
                longitude: -87.9065,
                licenses: ['LIC-WI-2022-139', 'LIC-FED-2023-418', 'LIC-STT-2024-062'],
                operationHours: {
                    monday: { open: '10:00 AM', close: '08:00 PM' },
                    tuesday: { open: '10:00 AM', close: '08:00 PM' },
                    wednesday: { open: '10:00 AM', close: '08:00 PM' },
                    thursday: { open: '10:00 AM', close: '08:00 PM' },
                    friday: { open: '10:00 AM', close: '08:00 PM' },
                    saturday: { open: '09:00 AM', close: '08:00 PM' },
                    sunday: { open: '10:00 AM', close: '06:00 PM' },
                },
            },
        ],
        state: 'Illinois',
        dealers: [
            { dealerName: 'Lakeland Auto Group', dealerId: 'DLR-00673' },
            { dealerName: 'Great Lakes Motors', dealerId: 'DLR-00688' },
        ],
        category: 'Residential',
        status: 'Active',
    },
];

export const FAKE_SEARCH_DATA = {
    states: [
        { id: 1, name: 'New York', code: 'NY' },
        { id: 2, name: 'Florida', code: 'FL' },
        { id: 3, name: 'Missouri', code: 'MO' },
        { id: 4, name: 'California', code: 'CA' },
        { id: 5, name: 'Illinois', code: 'IL' },
    ],
    dealers: [
        { dealerId: 'DLR-00492', dealerName: 'Reynolds Auto & Distribution' },
        { dealerId: 'DLR-00503', dealerName: 'Empire State Dealers' },
        { dealerId: 'DLR-00817', dealerName: 'Harborview Logistics Inc.' },
        { dealerId: 'DLR-00829', dealerName: 'Sunshine State Motors' },
        { dealerId: 'DLR-00845', dealerName: 'Gulf Coast Auto Group' },
        { dealerId: 'DLR-00231', dealerName: 'Prairie Star Dealers' },
        { dealerId: 'DLR-00244', dealerName: 'Midwest Auto Partners' },
        { dealerId: 'DLR-01105', dealerName: 'Westside Premier Motors' },
        { dealerId: 'DLR-01118', dealerName: 'Pacific Coast Auto' },
        { dealerId: 'DLR-01127', dealerName: 'Bay Area Dealers LLC' },
        { dealerId: 'DLR-00673', dealerName: 'Lakeland Auto Group' },
        { dealerId: 'DLR-00688', dealerName: 'Great Lakes Motors' },
    ],
    hosts: [
        {
            hostName: 'Skyline Ventures',
            address: '142 Orchard Blvd, Suite 300, New York, NY 10001',
        },
        { hostName: 'Pinnacle Holdings LLC', address: '78 Commerce Drive, Albany, NY 12203' },
        { hostName: 'Eastridge Properties', address: '901 Industrial Park Rd, Buffalo, NY 14201' },
        { hostName: 'Coastal Edge Group', address: '55 Bayview Ave, Miami, FL 33101' },
        { hostName: 'Sunbelt Realty Partners', address: '220 Palm Street, Orlando, FL 32801' },
        {
            hostName: 'Iron Peak Industries',
            address: '4400 Industrial Loop, Kansas City, MO 64101',
        },
        { hostName: 'Midlands Supply Co.', address: '1880 Commerce Blvd, St. Louis, MO 63101' },
        {
            hostName: 'Heartland Distributors',
            address: '700 Grain Exchange Rd, Springfield, MO 65801',
        },
        { hostName: 'Pacific Rim Enterprises', address: '1200 Harbor Way, Los Angeles, CA 90001' },
        {
            hostName: 'GoldenGate Assets LLC',
            address: '340 Market Street, San Francisco, CA 94101',
        },
        { hostName: 'BlueStar Management', address: '890 Lakefront Dr, Chicago, IL 60601' },
        { hostName: 'Lakeview Capital Group', address: '310 Michigan Ave, Detroit, MI 48201' },
        { hostName: 'Northshore Trading Co.', address: '515 Brewery Lane, Milwaukee, WI 53201' },
    ],
    territories: [
        { id: 1, name: 'Metro North District', state: 'New York' },
        { id: 2, name: 'Southern Bay Zone', state: 'Florida' },
        { id: 3, name: 'Central Plains Corridor', state: 'Missouri' },
        { id: 4, name: 'West Coast Hub', state: 'California' },
        { id: 5, name: 'Great Lakes Region', state: 'Illinois' },
    ],
    licenses: [
        { id: 1, code: 'LIC-NY-2024-001', state: 'NY', type: 'State' },
        { id: 2, code: 'LIC-FED-2023-774', state: 'NY', type: 'Federal' },
        { id: 3, code: 'LIC-FL-2023-301', state: 'FL', type: 'State' },
        { id: 4, code: 'LIC-FED-2023-512', state: 'FL', type: 'Federal' },
        { id: 5, code: 'LIC-MO-2022-045', state: 'MO', type: 'State' },
        { id: 6, code: 'LIC-CA-2024-102', state: 'CA', type: 'State' },
        { id: 7, code: 'LIC-IL-2023-211', state: 'IL', type: 'State' },
        { id: 8, code: 'LIC-STT-2024-062', state: 'WI', type: 'STT' },
    ],
    categories: [
        { id: 1, name: 'Commercial' },
        { id: 2, name: 'Residential' },
        { id: 3, name: 'Industrial' },
    ],
    status: [
        { id: 1, label: 'Active', color: '#4CAF50' },
        { id: 2, label: 'Inactive', color: '#F44336' },
        { id: 3, label: 'Pending', color: '#FF9800' },
    ],
};
